import React from 'react';
import styles from './NavMenu.module.css';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as GiftIcon } from '../../assets/gift.svg';
import { ReactComponent as TasksIcon } from '../../assets/tasks.svg';
import { ReactComponent as UsersIcon } from '../../assets/users.svg';
import { ReactComponent as ProfileIcon } from '../../assets/profile.svg';
import { ReactComponent as LeaderboardIcon } from '../../assets/leaderboad.svg';

import { useTelegram } from '../../app/providers/TelegramProvider';
import { useNavMenuStore } from '../../store/useNavMenuStore';

interface NavMenuProps {
  onRaffleOpen?: () => void;
}

const NavMenu: React.FC<NavMenuProps> = ({ onRaffleOpen }) => {
  const tg = window.Telegram?.WebApp;
  const location = useLocation();
  const { isVisible } = useNavMenuStore();
  const navigate = useNavigate();
  const { systemInsets, contentInsets } = useTelegram();

  const isTabActive = (path: string) => location.pathname === path;
  const isTabBlocked = (path: string) => false;

  if (!isVisible) return null;

  const handleTabClick = (path: string) => (e: React.MouseEvent) => {
    if (tg?.HapticFeedback) {
      tg.HapticFeedback.impactOccurred('medium');
    }

    if (path === '/raffles' && onRaffleOpen) {
      onRaffleOpen();
      return;
    }

    if (isTabBlocked(path)) {
      e.preventDefault();
      return;
    }

    navigate(path);
  };

  return (
    <>
      <div
        className={styles.navMenu}
      >
        <div className={styles.navMenu__content}>
          <button
              className={`${styles.navMenu__item} ${
                  isTabActive('/') ? styles['navMenu__item--active'] : ''
              } ${isTabBlocked('/') ? styles['navMenu__item--blocked'] : ''}`}
              onClick={handleTabClick('/')}
          >
            <GiftIcon className={styles.navMenu__icon}/>
            <span className={styles.navMenu__text}>Боксы</span>
          </button>
          <button
              className={`${styles.navMenu__item} ${
                  isTabActive('/tasks') ? styles['navMenu__item--active'] : ''
              } ${
                  isTabBlocked('/tasks') ? styles['navMenu__item--blocked'] : ''
              }`}
              onClick={handleTabClick('/tasks')}
          >
            <TasksIcon className={styles.navMenu__icon}/>
            <span className={styles.navMenu__text}>Задания</span>
          </button>
          <button
              className={`${styles.navMenu__item} ${
                  isTabActive('/friends') ? styles['navMenu__item--active'] : ''
              } ${
                  isTabBlocked('/friends') ? styles['navMenu__item--blocked'] : ''
              }`}
              onClick={handleTabClick('/friends')}
          >
            <UsersIcon className={styles.navMenu__icon}/>
            <span className={styles.navMenu__text}>Друзья</span>
          </button>
          <button
              className={`${styles.navMenu__item} ${
                  isTabActive('/leaderboard') ? styles['navMenu__item--active'] : ''
              } ${
                  isTabBlocked('/leaderboard') ? styles['navMenu__item--blocked'] : ''
              }`}
              onClick={handleTabClick('/leaderboard')}
          >
            <LeaderboardIcon className={styles.navMenu__icon}/>
            <span className={styles.navMenu__text}>Лидеры</span>
          </button>
          <button
              className={`${styles.navMenu__item} ${
                  isTabActive('/profile') ? styles['navMenu__item--active'] : ''
              } ${
                  isTabBlocked('/profile') ? styles['navMenu__item--blocked'] : ''
              }`}
              onClick={handleTabClick('/profile')}
          >
            <ProfileIcon className={styles.navMenu__icon}/>
            <span className={styles.navMenu__text}>Профиль</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NavMenu;
